// ui/Badge — THE status badge (Design Standard v1): one pill shape, semantic
// colours only (success · warning · danger · info · neutral), plus `accent` for a
// small selected/AI indicator. The pre-standard colour names map onto the
// semantic set so every existing caller lands on the same five looks.
import React from 'react';
import clsx from 'clsx';
import './ds.css';

const TONE = {
  success: 'success', warning: 'warning', danger: 'danger', info: 'info', neutral: 'neutral', accent: 'accent',
  emerald: 'success', green: 'success', yellow: 'warning', amber: 'warning', red: 'danger', rose: 'danger',
  blue: 'info', gray: 'neutral', grey: 'neutral', purple: 'neutral',
};

export default function Badge({ children, color = 'neutral', tone, className = '', ...rest }) {
  const t = TONE[tone || color] || 'neutral';
  return (
    <span className={clsx('ds-badge', t !== 'neutral' && `ds-badge--${t}`, className)} {...rest}>
      {children}
    </span>
  );
}

export { Badge };
